import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Modal.css";

const BASE_URL = 'https://testwire.wockhardt.com';
const jwt = localStorage.getItem('jwt'); // get the JWT token from local storage
console.log('JWT', jwt);

export default function Modal() {
  const [modal, setModal] = useState(true);
  const [data1, setData1] = useState(null);
  const [modalId, setModalId] = useState(null); // add modalId state variable
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    //
    let responseData = localStorage.getItem("responseData");
    if (responseData) {
      let jwtDataParsed = JSON.parse(responseData);
      let id = jwtDataParsed.user.id;
      setUserId(id);
    }
    //
    fetchData1();
  }, [modal]);

  const toggleModal = () => {
    setModal(!modal);
  };

  if(modal) {
    document.body.classList.add('active-modal')
  } else {
    document.body.classList.remove('active-modal')
  }

  const fetchData1 = () => {
    axios.get(`${BASE_URL}/api/modals?populate=*`,{
      headers: {
          Authorization: `Bearer ${jwt}`,
          'Content-Type': 'application/json'
        },
  })
      .then(res => {
        setData1(res.data);
        let id = res.data.id;
        console.log('Modelid:', res.data.id);
        console.log('API data modal:', data1);

      })
      .catch(error => {
        console.error('API error for get-modal-details:', error);
      });
  };

/* Working below code which change agree value */
  const updateData2 = (id, checked) => {
    const updatedData = {
      data: {
          Agree: checked
      },
    };
  
    axios
      .put(`${BASE_URL}/api/modals/${id}`, updatedData, {
        headers: {
          Authorization: `Bearer ${jwt}`,
          "Content-Type": "application/vnd.api+json",
        },
      })
      .then((res) => {
        setData1((prevData) => {
          const newData = { ...prevData };
          const itemIndex = newData.data.findIndex(
            (item) => item.id === modalId
          );
          if (itemIndex > -1) {
            newData.data.splice(itemIndex, 1);
          }
          return newData;
        });
      })
      .catch((error) => {
        console.error("API error for Posting modal:", error);
      });

      // Update the user data
    const updatedUserData = {
      shouldHitThirdPartyAPI: checked
  };
  //const userId = "4"; // Replace "123" with the actual user ID

  axios
    .put(`${BASE_URL}/api/users/${userId}`, updatedUserData, {
      headers: {
        Authorization: `Bearer ${jwt}`,
        "Content-Type": "application/vnd.api+json",
      },
    })
    .then((res) => {
      console.log("User data updated:", res.data);
    })
    .catch((error) => {
      console.error("API error for Updating user:", error);
    });
  };

  
  /*const handleAgreeChange = (e, id) => {
    const checked = e.target.checked;
    setData1((prevData) => {
      const newData = { ...prevData };
      const itemIndex = newData.data.findIndex((item) => item.id === id);
      if (itemIndex > -1) {
        newData.data[itemIndex].Agree = checked;
        setModalId(id);
        updateData2(id, checked); // Call the updateData2 function with id and checked parameters
      }
      return newData;
    });
  };*/


  const handleAgreeChange = (e, id) => {
    const checked = e.target.checked;
    setData1((prevData) => {
      const newData = { ...prevData };
      const itemIndex = newData.data.findIndex((item) => item.id === id);
      if (itemIndex > -1) {
        newData.data[itemIndex].Agree = checked;
        setModalId(id);
        updateData2(id, checked); // Call the updateData2 function with id and checked parameters
      }
      if (newData.data.every((item) => item.Agree)) {
        setModal(false); // Close the modal if all checkboxes are checked
      }
      return newData;
    });
  };
  
            
  if (data1 === null) {
    return <div>Loading...</div>;
  }

  return (
    <>
      {/*<button onClick={toggleModal} className="btn-modal">
        Open
  </button>*/}
      {modal && (
        <div className="modal">
          <div onClick={toggleModal} disabled className="overlay"></div>
          <div className="modal-content">
            {data1 && Array.isArray(data1.data) && (
              <p>
                {data1.data.map(item => (
                  <div key={item.id}>  
                  <p className='text-xs'>{item.attributes.Message}</p>
                  {/*<input type="checkbox" id={item.id} name="Agree" value={item.attributes.Agree} checked={item.attributes.Agree} onChange={(e) => handleAgreeChange(e, item.id)} />*/}
                  <div className="flex" style={{marginTop:'15px'}}>
                    <input type="checkbox" id={item.id} name="Agree" value={item.attributes.Agree} checked={item.attributes.Agree} onChange={(e) => handleAgreeChange(e, item.id)}/><p>&nbsp;</p>
                    <p className='font-semibold text-xs text-headings'>{item.attributes.Title}</p>
                  </div>
                  
                 
                  </div>
                ))}     
              </p>
            )}
            {/*<button className="close-modal" onClick={() => updateData2(data1.data[0].id)}>CLOSE</button>*/}
          </div>
        </div>
      )}
    </>
  );
}
